import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=faec6e7e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=faec6e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faec6e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faec6e7e')) {
      api.createRecord('faec6e7e', component.options)
    } else {
      api.reload('faec6e7e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=faec6e7e&scoped=true&", function () {
      api.rerender('faec6e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C07swQ0fYdp1/JS/comp/GuestBox.vue"
export default component.exports